import React from 'react';

import { stylesContent } from '../../EncounterInvoiceTemplateStyles';

export const SubHeader = ({ item }) => {
  return (
    <div
      style={{ ...stylesContent.groupSubHeader, display: 'flex' }}
      className="row-item"
      data-testid="sub-group-amount-calculation"
    >
      {`${item.subGroupName}`}
    </div>
  );
};
